export default {
  no_storefront_found: {
    title: 'Geen storefront gevonden',
    description: 'Maak een storefront aan.',
  },
};
